import { useMerchant } from '../../../../contexts/MerchantContext';
import { useGetMerchantQuery, useGetOnboardingQuery } from '../../../../store/modules/merchant/api';
import { isShopifyMerchant } from '../../../../util/shopifyExternalId';

/**
 * Whether Agent Hub should expose Shopify provisioning for the current merchant.
 * Shopify stores are identified by a *.myshopify.com externalPlatformId.
 */
export const useShopifyProvisioningEligibility = () => {
  const { merchantId } = useMerchant();
  const { data: merchant, isLoading: isMerchantLoading } = useGetMerchantQuery(merchantId ?? '', {
    skip: !merchantId,
  });

  const isShopifyStore = isShopifyMerchant(merchant?.externalPlatformId);
  const merchantPlatformResolved = Boolean(merchantId) && !isMerchantLoading;
  const shouldFetchOnboarding = merchantPlatformResolved && isShopifyStore;

  const {
    data: onboarding,
    isLoading: isOnboardingLoading,
    isError: isOnboardingError,
    isSuccess: hasOnboarding,
    refetch: refetchOnboarding,
  } = useGetOnboardingQuery(
    { merchantId: merchantId ?? '', systemOfOrigin: 'shopify' },
    { skip: !shouldFetchOnboarding },
  );

  const isEligible = isShopifyStore;
  const isLoading =
    isMerchantLoading ||
    (shouldFetchOnboarding && isOnboardingLoading && !onboarding && !isOnboardingError);

  return {
    merchantId,
    merchant,
    onboarding: onboarding?.systemOfOrigin === 'shopify' ? onboarding : undefined,
    isShopifyStore,
    isEligible,
    isLoading,
    hasOnboarding,
    isOnboardingError,
    refetchOnboarding,
  };
};
